import { render } from "./ModalUploadFiltro.vue?vue&type=template&id=68ccfadc&scoped=true&ts=true"
import script from "./ModalUploadFiltro.vue?vue&type=script&lang=ts"
export * from "./ModalUploadFiltro.vue?vue&type=script&lang=ts"

import "./ModalUploadFiltro.vue?vue&type=style&index=0&id=68ccfadc&scoped=true&lang=css"

import exportComponent from "/Users/camp2/Devs/indicar/indicar-gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68ccfadc"]])

export default __exports__